<template>
    <section class="faq-index">
        <div>
            <h2>{{ title }}</h2>
            <div class="faq-index-tiles vm">
                <div
                    tabindex="0"
                    class="faq-index-tile"
                    v-for="(item, index) in items"
                    v-bind:key="index"
                    @click="scrollTo(`faq-${item?.documentId}`)"
                >
                    <img
                        v-if="item?.icon?.url"
                        :src="item?.icon?.url"
                        :alt="item?.icon?.alternativeText || ''"
                    />
                    <div>
                        {{ item?.category }}
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'FaqIndexSection',
    props: {
        title: String,
        description: String,
        items: Array,
    },
    methods: {
        scrollTo(elId) {
            const el = document.getElementById(elId)
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.faq-index {
    text-align: left;

    .faq-index-tiles {
        flex-wrap: wrap;
        text-align: center;
        align-items: stretch;
        gap: 12px;
        padding: 12px;
    }

    /* Tile: soft border, gentle hover-lift, pink underline-glow
       grows when hovered. Same vibe as the pricing tiles, scaled
       down for an index/nav role rather than a CTA. */
    .faq-index-tile {
        flex-grow: 1;
        height: auto;
        padding: 18px 14px;
        cursor: pointer;
        max-width: 200px;
        width: 30%;
        text-align: center;
        vertical-align: top;
        display: inline-block;
        background: var(--bzioup-bg-color-A);
        border-radius: $border-radius;
        border: 1px solid rgba(0, 0, 0, 0.08);
        position: relative;
        transition: transform 220ms cubic-bezier(0.2, 0.8, 0.3, 1),
                    box-shadow 220ms ease-out,
                    border-color 220ms ease-out;

        img {
            max-width: 70px;
        }
    }

    .faq-index-tile::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 8px;
        width: 0;
        height: 2px;
        border-radius: 2px;
        background: var(--bzioup-color-pink);
        transform: translateX(-50%);
        transition: width 240ms cubic-bezier(0.2, 0.8, 0.3, 1);
    }

    .faq-index-tile:hover {
        transform: translateY(-3px);
        border-color: var(--bzioup-color-pink);
        box-shadow: var(--bzioup-shadow-soft);
    }

    .faq-index-tile:hover::after {
        width: 32px;
    }
}
</style>
